import { getField, updateField } from 'vuex-map-fields';
import EngineConfig from '../../config/EngineConfig';

export default {
  namespaced: true,
  state: {
    ageInput: EngineConfig.AgeNow,
    sexInput: EngineConfig.Sex,
    retirementAgeInput: EngineConfig.RetirementAge,
    salaryInput: EngineConfig.Salary,
    superannuationBalanceInput: EngineConfig.SuperannuationBalance,

    ageInput_2: EngineConfig.AgeNow_2,
    sexInput_2: EngineConfig.Sex_2,
    retirementAgeInput_2: EngineConfig.RetirementAge_2,
    salaryInput_2: EngineConfig.Salary_2,
    superannuationBalanceInput_2: EngineConfig.SuperannuationBalance_2,
  },

  getters: {
    getField,
  },

  mutations: {
    updateAgeInput(state, value) {
      state.ageInput = value;
    },

    updateSexInput(state, value) {
      state.sexInput = value;
    },

    updateRetirementAgeInput(state, value) {
      state.retirementAgeInput = value;
    },

    updateSalaryInput(state, value) {
      state.salaryInput = value;
    },

    updateSuperannuationBalanceInput(state, value) {
      state.superannuationBalanceInput = value;
    },

    updateAgeInput_2(state, value) {
      state.ageInput_2 = value;
    },

    updateSexInput_2(state, value) {
      state.sexInput_2 = value;
    },

    updateRetirementAgeInput_2(state, value) {
      state.retirementAgeInput_2 = value;
    },

    updateSalaryInput_2(state, value) {
      state.salaryInput_2 = value;
    },

    updateSuperannuationBalanceInput_2(state, value) {
      state.superannuationBalanceInput_2 = value;
    },

    updateField

  },
};
